import React from "react"

import * as routes from '../../../util/routes'

import {NavLink} from 'react-router-dom';

export default class LoansHeander extends React.Component {

	render() {
		return (
			<div className="loans-header">
				<span>{this.props.row.title}</span>
				{/*<NavLink to={'/' + this.props.currentLocalAuthority.slug + routes.RETROSPECTIVE_DEBT}><i className="fa fa-help" /></NavLink>*/}
			</div>
		)
	}

}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/loans-header.js